/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EmailType } from '../model/emailType';
import { InlineResponse400 } from '../model/inlineResponse400';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EmailService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param type 
     * @param invitationUid 
     * @param email 
     * @param receiverFirstName 
     * @param receiverLastName 
     * @param receiverRole 
     * @param receiverEmail 
     * @param senderFirstName 
     * @param senderLastName 
     * @param senderEmail 
     * @param senderRole 
     * @param resourceName 
     * @param language 
     * @param returnUrl 
     * @param token 
     * @param tokenLength 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public emailPost(type?: EmailType, invitationUid?: string, email?: string, receiverFirstName?: string, receiverLastName?: string, receiverRole?: string, receiverEmail?: string, senderFirstName?: string, senderLastName?: string, senderEmail?: string, senderRole?: string, resourceName?: string, language?: string, returnUrl?: string, token?: string, tokenLength?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public emailPost(type?: EmailType, invitationUid?: string, email?: string, receiverFirstName?: string, receiverLastName?: string, receiverRole?: string, receiverEmail?: string, senderFirstName?: string, senderLastName?: string, senderEmail?: string, senderRole?: string, resourceName?: string, language?: string, returnUrl?: string, token?: string, tokenLength?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public emailPost(type?: EmailType, invitationUid?: string, email?: string, receiverFirstName?: string, receiverLastName?: string, receiverRole?: string, receiverEmail?: string, senderFirstName?: string, senderLastName?: string, senderEmail?: string, senderRole?: string, resourceName?: string, language?: string, returnUrl?: string, token?: string, tokenLength?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public emailPost(type?: EmailType, invitationUid?: string, email?: string, receiverFirstName?: string, receiverLastName?: string, receiverRole?: string, receiverEmail?: string, senderFirstName?: string, senderLastName?: string, senderEmail?: string, senderRole?: string, resourceName?: string, language?: string, returnUrl?: string, token?: string, tokenLength?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('Type', <any>type);
        }
        if (invitationUid !== undefined && invitationUid !== null) {
            queryParameters = queryParameters.set('InvitationUid', <any>invitationUid);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('Email', <any>email);
        }
        if (receiverFirstName !== undefined && receiverFirstName !== null) {
            queryParameters = queryParameters.set('ReceiverFirstName', <any>receiverFirstName);
        }
        if (receiverLastName !== undefined && receiverLastName !== null) {
            queryParameters = queryParameters.set('ReceiverLastName', <any>receiverLastName);
        }
        if (receiverRole !== undefined && receiverRole !== null) {
            queryParameters = queryParameters.set('ReceiverRole', <any>receiverRole);
        }
        if (receiverEmail !== undefined && receiverEmail !== null) {
            queryParameters = queryParameters.set('ReceiverEmail', <any>receiverEmail);
        }
        if (senderFirstName !== undefined && senderFirstName !== null) {
            queryParameters = queryParameters.set('SenderFirstName', <any>senderFirstName);
        }
        if (senderLastName !== undefined && senderLastName !== null) {
            queryParameters = queryParameters.set('SenderLastName', <any>senderLastName);
        }
        if (senderEmail !== undefined && senderEmail !== null) {
            queryParameters = queryParameters.set('SenderEmail', <any>senderEmail);
        }
        if (senderRole !== undefined && senderRole !== null) {
            queryParameters = queryParameters.set('SenderRole', <any>senderRole);
        }
        if (resourceName !== undefined && resourceName !== null) {
            queryParameters = queryParameters.set('ResourceName', <any>resourceName);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('Language', <any>language);
        }
        if (returnUrl !== undefined && returnUrl !== null) {
            queryParameters = queryParameters.set('ReturnUrl', <any>returnUrl);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('Token', <any>token);
        }
        if (tokenLength !== undefined && tokenLength !== null) {
            queryParameters = queryParameters.set('TokenLength', <any>tokenLength);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('post',`${this.basePath}/Email`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
